// Mock data for Numerology King website (frontend-only)
import { Hash, Orbit, Home, Flame, Instagram, Youtube, Facebook } from 'lucide-react';

export const brand = {
  name: 'Numerology King',
  by: 'By Vivechan Gautam',
  tagline: 'KNOW YOUR NUMBERS, KNOW YOURSELF',
  subtitle: 'Ancient Wisdom. Modern Guidance.',
  intro: 'Transforming Lives Through The Power of Numbers, Planets, Vastu & Divine Rituals.',
  whatsapp: '+91 8437151719',
  whatsappMsg: 'Namaste! I would like to know more about my numbers.',
  socials: [
    { name: 'Instagram', icon: Instagram, url: 'https://www.instagram.com/nkbyvivechangautam/' },
    { name: 'YouTube', icon: Youtube, url: 'https://youtube.com/@nkbyvivechangautam?si=eEQXV2P-k434hxYr' },
    { name: 'Facebook', icon: Facebook, url: 'https://www.facebook.com/vivechan.gautam' },
  ],
};

export const navLinks = [
  { label: 'Home', to: 'home' },
  { label: 'About', to: 'about' },
  { label: 'Services', to: 'services' },
  { label: 'Offices', to: 'offices' },
  { label: 'Voices', to: 'testimonials' },
  { label: 'Book Now', to: 'booking' },
];

export const services = [
  {
    id: 'numerology',
    icon: Hash,
    title: 'Numerology',
    desc: 'Decode your numbers, unlock your destiny',
    long: 'Your name and birth date carry a vibration. We calculate your Driver, Conductor & Soul numbers to reveal your true path, lucky numbers, and the corrections that align you with abundance.',
    numbers: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
    price: '₹2100',
  },
  {
    id: 'astrology',
    icon: Orbit,
    title: 'Astrology',
    price: '₹2100',
    desc: 'Align with the cosmos for a better tomorrow',
    long: 'A precise reading of the nine planets in your chart. Understand timing, remedies, and the celestial forces shaping your career, relationships and health.',
  },
  {
    id: 'vastu',
    icon: Home,
    title: 'Vastu',
    price: '₹51,000',
    desc: 'Harmonize your space, attract positivity',
    long: 'Balance the five elements in your home and workplace. Simple, non-demolition Vastu corrections that invite prosperity, peace and positive energy flow.',
  },
  {
    id: 'hawan',
    icon: Flame,
    title: 'Hawan',
    price: '₹51,000',
    desc: 'Sacred rituals for peace, prosperity & protection',
    long: 'Authentic Vedic fire rituals performed by learned pandits. Cleanse negative energies and invoke divine blessings for you and your family.',
  },
];

export const offices = [
  {
    id: 'jaipur',
    city: 'Jaipur',
    subtitle: 'Spiritual Capital of Rajasthan',
    desc: 'Guidance with Royal Grace',
    image: 'https://images.unsplash.com/photo-1650530777057-3a7dbc24bf6c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxIYXdhJTIwTWFoYWx8ZW58MHx8fHwxNzg4MDE3ODgzfDA&ixlib=rb-4.1.0&q=85',
    address: '406 Parth Crystal, Swami Vihar, Jaipur',
  },
  {
    id: 'delhi',
    city: 'Delhi',
    subtitle: 'The Heart of India',
    desc: 'Solutions for Modern Lives',
    image: 'https://images.unsplash.com/photo-1705927122615-02dcef3b1465?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxJbmRpYSUyMEdhdGV8ZW58MHx8fHwxNzg4MDE3ODgzfDA&ixlib=rb-4.1.0&q=85',
    address: 'WC6/16, Sainik Farm, Delhi',
  },
  {
    id: 'chandigarh',
    city: 'Chandigarh',
    subtitle: 'The City Beautiful',
    desc: 'Balanced Living, Prosperous Future',
    image: 'https://images.unsplash.com/photo-1697306323210-5972e68c622d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxDaGFuZGlnYXJofGVufDB8fHx8MTc4ODAyNDYxNXww&ixlib=rb-4.1.0&q=85',
    address: '2357 Sec 23 D, Chandigarh',
  },
];

export const stats = [
  { value: '25,000+', label: 'Lives Transformed' },
  { value: '15+', label: 'Years of Wisdom' },
  { value: '3', label: 'City Offices' },
  { value: '4.9', label: 'Client Rating' },
];

export const testimonials = [
  {
    name: 'Ananya Sharma',
    city: 'Jaipur',
    text: 'After the name correction suggested by Vivechan ji, my stalled career finally moved. Within months I got the promotion I had waited years for.',
    rating: 5,
  },
  {
    name: 'Rohit Malhotra',
    city: 'Delhi',
    text: 'The Vastu changes were simple, no breaking of walls. The peace in our home returned almost immediately. Truly grateful for the guidance.',
    rating: 5,
  },
  {
    name: 'Simran Kaur',
    city: 'Chandigarh',
    text: 'My numerology reading was frighteningly accurate. The remedies gave me clarity and confidence I never had before. Highly recommended.',
    rating: 5,
  },
  {
    name: 'Deepak Verma',
    city: 'Delhi',
    text: 'The hawan for our new business brought a wave of positive energy. Orders picked up and the whole team felt lighter. Divine experience.',
    rating: 5,
  },
];

export const services_detail_note = 'All readings are personalised. Book a session to receive your complete report.';
